export enum AssetType {
  None = 0,
  Site = 1,
  Landing = 2,
  Custom = 3,
  CustomSite = 4,
  CustomLandingPage = 5,
  Video = 6,
  Banner = 7,
  Facebook = 8,
  ExternalAPI = 10,
}
